import {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {usePageURLContext} from "../../../contexts/pageURLContext";
import {requestListofSensorAlerts} from "../../../redux/Actions/alerts.actions";
import {
  getSensorAlertsList,
  getTotalCount,
  getPaginationUrls,
} from "../../../redux/Selectors/alerts.selector";
import {generateQueryUrl} from "../../../helpers/generateQueryUrl";
import {sensorAlertListURL} from "./sensorAlertsTable.constants";

export const useFetchSensorAlerts = () => {
  const {pageUrl} = usePageURLContext();
  const dispatch = useDispatch();

  const freshFetch = () => {
    dispatch(requestListofSensorAlerts());
  };

  const refetch = () => {
    dispatch(requestListofSensorAlerts(pageUrl));
  };

  return {refetch, freshFetch};
};

export const useSensorAlertTableData = () => {
  const dispatch = useDispatch();
  const {refetch, freshFetch} = useFetchSensorAlerts();
  const {setPageUrl} = usePageURLContext();
  const [currentPage, setCurrentPage] = useState(1);
  const sensorAlertsList = useSelector(getSensorAlertsList);
  const alertTotalCount = useSelector(getTotalCount);
  const alertUrls = useSelector(getPaginationUrls);

  useEffect(() => {
    freshFetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchAfterDelete = () => {
    if (sensorAlertsList.length === 1) {
      // If the last alert on the current page is deleted, reset to the first page
      setCurrentPage(1);
      setPageUrl("");
      freshFetch();
    } else {
      refetch();
    }
  };

  const handlePageChange = (page) => {
    const url = currentPage < page ? alertUrls?.nextUrl : alertUrls?.prevUrl;
    dispatch(requestListofSensorAlerts(url));
    setCurrentPage(page);
    setPageUrl(url);
  };

  const paginationConfig = {
    currentPage,
    onPageChange: handlePageChange,
  };

  const handleSearch = (tokens) => {
    if (tokens?.length > 0) {
      const searchUrl = generateQueryUrl(sensorAlertListURL, tokens);
      dispatch(requestListofSensorAlerts(searchUrl));
      setPageUrl(searchUrl);
      setCurrentPage(1);
    } else {
      freshFetch();
      setPageUrl("");
      setCurrentPage(1);
    }
  };

  return {
    alertTotalCount,
    fetchAfterDelete,
    handleSearch,
    paginationConfig,
    sensorAlertsList,
  };
};
